import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
};

export const RouteIcon = ({ fill = 'currentColor', stroke = 'currentColor', strokeWidth = '2.4', width = 80, height = 80, ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M45 54.5C45 48.701 49.701 44 55.5 44C61.299 44 66 48.701 66 54.5C66 62.0479 55.503 71.9972 55.5 72C55.5 72 45 62.049 45 54.5ZM47.4004 54.5C47.4004 55.8675 47.8881 57.5229 48.793 59.3564C49.685 61.1638 50.8997 62.9804 52.1562 64.623C53.3584 66.1944 54.5677 67.5632 55.5 68.5645C56.4323 67.5632 57.6416 66.1944 58.8437 64.623C60.1003 62.9804 61.315 61.1638 62.207 59.3564C63.1119 57.5229 63.5996 55.8675 63.5996 54.5C63.5996 50.0265 59.9735 46.4004 55.5 46.4004C51.0265 46.4004 47.4004 50.0265 47.4004 54.5ZM51 54.5C51 52.0147 53.0147 50 55.5 50C57.9853 50 60 52.0147 60 54.5C60 56.9853 57.9853 59 55.5 59C53.0147 59 51 56.9853 51 54.5ZM55.5 56.5996C56.6598 56.5996 57.5996 55.6598 57.5996 54.5C57.5996 53.3402 56.6598 52.4004 55.5 52.4004C54.3402 52.4004 53.4004 53.3402 53.4004 54.5C53.4004 55.6598 54.3402 56.5996 55.5 56.5996Z"
                fill={fill}
            />
            <path
                d="M17.6667 17H54.6667C60.1896 17 64.6667 21.4772 64.6667 27V27C64.6667 32.5228 60.1896 37 54.6667 37H27.6667C22.1439 37 17.6667 41.4772 17.6667 47V47C17.6667 52.5228 22.1439 57 27.6667 57H47.6667"
                stroke={stroke}
                strokeWidth={strokeWidth}
            />
            <circle cx="19" cy="17" r="3.8" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        </svg>
    );
};
